import { render, staticRenderFns } from "./ResultStep.vue?vue&type=template&id=c5e16d48&scoped=true"
import script from "./ResultStep.vue?vue&type=script&lang=ts"
export * from "./ResultStep.vue?vue&type=script&lang=ts"
import style0 from "./ResultStep.vue?vue&type=style&index=0&id=c5e16d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e16d48",
  null
  
)

export default component.exports